import { MoonOutlined, MoreOutlined, SunOutlined } from "@ant-design/icons";
import { Dropdown, Switch, MenuProps } from "antd";
import { useContext } from "react";

import {
  CompanyProviderContext,
  Company,
} from "../../providers/company/context";
import { useTheme } from "../../providers/theme/useTheme";
import { CONFIG } from "../../utils/config";

const ToggleMenu = () => {
  const { theme, setTheme } = useTheme();

  const toggleTheme = (checked: boolean) => {
    setTheme(checked ? "dark" : "default");
  };

  const { currentCompany, setCurrentCompany, companies } = useContext(
    CompanyProviderContext,
  );

  const handleCompanyClick = (company: Company) => {
    window.location.href = "/";
    setCurrentCompany(company);
  };

  const items: MenuProps["items"] = [
    {
      key: "company",
      title: "Company",
      label: currentCompany?.name ?? "---",
      children:
        companies.length > 1
          ? companies.map((company) => ({
              key: company.id,
              label: company.name,
              onClick: () => {
                handleCompanyClick(company);
              },
            }))
          : undefined,
    },
    {
      key: "dark",
      title: "Dark Mode",
      icon: (
        <>
          Theme&nbsp;&nbsp;
          <Switch
            checked={theme === "dark"}
            onChange={toggleTheme}
            checkedChildren={<MoonOutlined />}
            unCheckedChildren={<SunOutlined />}
          />
        </>
      ),
    },
    {
      key: "logout",
      title: "Logout",
      label: "Logout",
      onClick: () => {
        // Redirect to the logout endpoint
        window.location.href = CONFIG.LOGOUT_URL;
      },
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <a
        onClick={(e) => {
          e.preventDefault();
        }}
      >
        <MoreOutlined style={{ fontSize: "20px", color: "white" }} />
      </a>
    </Dropdown>
  );
};

export default ToggleMenu;
